import { render } from "./general-settings.vue?vue&type=template&id=51a14743"
import script from "./general-settings.vue?vue&type=script&lang=js"
export * from "./general-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__